// extracted by mini-css-extract-plugin
module.exports = {"media-inquiries":"InquiriesInformation_media-inquiries__fq4tp","inquiry-block":"InquiriesInformation_inquiry-block__ozuuq"};